<!-- Separator -->
@if (item.separator) {
  <li class="my-1 border-t border-white/10 mx-1 list-none"></li>
}

<!-- Menu item with link (leaf node - no children) -->
@if (!item.separator && item.show && !item.items) {
  <li class="list-none">
    <a [routerLink]="item.routerLink"
       [queryParams]="item.queryParams"
       routerLinkActive="!bg-white/10 !text-white font-semibold shadow-sm"
       [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
       [attr.target]="item.target"
       (click)="itemClick($event)"
       class="flex items-center gap-3 px-3 py-2.5 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-all duration-200 cursor-pointer group no-underline">
      @if (item.icon) {
        <lucide-icon [img]="item.icon" class="flex-shrink-0" [size]="18"></lucide-icon>
      }
      @if (appMain.sidebarActive || appMain.sidebarStatic) {
        <span class="text-sm font-medium flex-1 truncate">{{ item.label }}</span>
        @if (item.badge) {
          <span class="ml-auto inline-flex items-center justify-center px-2 py-0.5 text-xs font-bold rounded-full bg-blue-900/40 text-blue-300">{{ item.badge }}</span>
        }
      }
    </a>
  </li>
}

<!-- Menu item with children (submenu) -->
@if (!item.separator && item.show && item.items) {
  <li class="list-none">
    <a (click)="itemClick($event)"
       class="flex items-center gap-3 px-3 py-2.5 rounded-xl text-slate-300 hover:bg-white/5 hover:text-white transition-all duration-200 cursor-pointer group no-underline">
      @if (item.icon) {
        <lucide-icon [img]="item.icon" class="flex-shrink-0" [size]="18"></lucide-icon>
      }
      @if (appMain.sidebarActive || appMain.sidebarStatic) {
        <span class="text-sm font-medium flex-1 truncate">{{ item.label }}</span>
        <i class="pi pi-angle-down text-xs transition-transform duration-200 ml-auto text-slate-400"
           [class.rotate-180]="active"></i>
      }
    </a>

    <!-- Submenu -->
    @if (active) {
      <ul class="ml-4 mt-0.5 flex flex-col gap-0.5 list-none p-0" [@children]="'visibleAnimated'">
        @for (child of item.items; track child; let i = $index) {
          <li app-menuitem [item]="child" [index]="i" [parentKey]="key" class="list-none"></li>
        }
      </ul>
    }
  </li>
}
